<template>
  <div class="count-down" :class="inline?'count-down_inline':''">
    <p class="count-down_label">{{label}}</p>
    <p class="count-down_time" v-if="time">
      <slot :time="time">
        <template v-if="showDays">
          <span>{{time.days}}</span>
          <span>天</span>
          <span>{{time.hours}}</span>
          <span>{{gaps.hours}}</span>
        </template>
        <template v-if="!showDays">
          <span>{{time.fullhours}}</span>
          <span>{{gaps.fullhours}}</span>
        </template>
        <span>{{time.minutes}}</span>
        <span>{{gaps.minutes}}</span>
        <span>{{time.seconds}}</span>
        <span v-if="gaps.seconds!==':'">{{gaps.seconds}}</span>
      </slot>
    </p>
  </div>
</template>

<script>
  import {LeftTimer} from '../../utils/formatTime';

  export default {
	name: 'CountDown',
	props: {
	  inline: Boolean,
	  showDays: Boolean,
	  dotGap: Boolean,
	  start: [Number, String],
	  end: [Number, String],
	  startLabel: {
		type: String,
		default: '距离开始'
	  },
	  endLabel: {
		type: String,
		default: '已结束'
	  },
	  onlineLabel: {
		type: String,
		default: '距离结束'
	  },
	},
	components: {},
	data() {
	  return {
		time: null
	  };
	},
	created() {
	  this.timer = new LeftTimer({start: this.start, end: this.end});
	  this.timer.on('fresh', time => {
		this.time = time;
	  });
	},
	methods: {},
	computed: {
	  label() {
		if (!this.time) return '';
		const {isOnline, isStart, isEnd} = this.time;
		if (isEnd) return this.endLabel;
		if (isOnline) return this.onlineLabel;
		if (!isStart) return this.startLabel;
	  },
	  gaps() {
		if (this.dotGap) return {
		  fullhours: ':',
		  hours: ':',
		  minutes: ':',
		  seconds: ':',
		};
		return {
		  fullhours: '时',
		  hours: '时',
		  minutes: '分',
		  seconds: '秒',
		};
	  }
	}
  };
</script>

<style lang="less" rel="stylesheet/less">

  .count-down {

    .count-down_label {
      font-size: 12px;
    }

    &.count-down_inline {
      display: flex;
      font-size: 12px;
      justify-content: space-between;
    }

  }
</style>
